/**
 * Datos minimos para etiquetar a la contraparte de un documento. Es estructural a
 * proposito: sirve igual para el maestro de clientes, el de proveedores y el snapshot
 * que guarda el propio documento.
 */
export type ClientNameFields = {
    nombre?: string | null;
    nombre_comercial?: string | null;
};

/**
 * Etiqueta con la que se muestra un cliente o proveedor en selects, listados e
 * impresiones: `{nombre}` a secas, o `{nombre} - {nombre comercial}` cuando tiene uno.
 */
export const buildClientOptionLabel = (client: ClientNameFields): string => {
    const nombre = `${client.nombre || ""}`.trim();
    const nombreComercial = `${client.nombre_comercial || ""}`.trim();

    if (!nombreComercial) {
        return nombre;
    }
    return nombre ? `${nombre} - ${nombreComercial}` : nombreComercial;
};
